import useEventListener from "./useEventListener";

export type UDSEventHandler = (event: MouseEvent | TouchEvent) => void;

function useOnClickOutside<T extends HTMLElement = HTMLElement>(
  handler: UDSEventHandler,
  eventType: keyof WindowEventMap | string = "mousedown",
  // ref: RefObject<T> | RefObject<T>[],
  ...rest
): void {
  useEventListener(eventType, (event) => {
    const data: Array<T> = (rest || [])
      .map((refItem) => refItem?.current)
      .filter((it) => !!it);

    /** Do nothing if clicking ref's element or descendent elements */
    /** Checks casual targets */
    /** Then Touch targets */
    if (
      !handler ||
      !data.length ||
      data.find((item) => item?.contains?.(event.target as Node))
    ) {
      return;
    }

    handler(event as unknown as MouseEvent | TouchEvent);
  });
}

export default useOnClickOutside;
